import { useParams } from 'react-router';

import { useGetAdmissionTestingQuery } from '@/api/endpoints/schools/schoolSelectionPanel';
import type { IApiError } from '@/api/types';
import { FetchErrorSection, Loader } from '@/shared/components';

import { ESelectionPanelTabs } from '../../../_components/SelectionPanelHeader/consts';
import { SelectionPanelHeader } from '../../../_components/SelectionPanelHeader/SelectionPanelHeader';
import { UnavailableSection } from '../../../_components/UnavailableSection/UnavailableSection';

import { TestingParticipantsPage } from './TestingParticipantsPage';
import styles from './TestingParticipantsPage.module.scss';

export const TestingParticipantsPageWrapper = () => {
  const { id: schoolId } = useParams();

  const {
    data: admissionTestingData,
    isLoading: isTestingLoading,
    isError: isTestingFetchError,
    error: testingError,
  } = useGetAdmissionTestingQuery({ schoolId: Number(schoolId) });

  if (isTestingLoading) {
    return <Loader isSpinning />;
  }

  if (isTestingFetchError) {
    if ((testingError as IApiError)?.status === 404) {
      return (
        <div className={styles.wrapper}>
          <SelectionPanelHeader currentTab={ESelectionPanelTabs.Testing} />
          <UnavailableSection unavailableText="Данная секция станет доступна после завершения предыдущего этапа хотя бы одним участником" />
        </div>
      );
    }
    return <FetchErrorSection />;
  }

  if (admissionTestingData) {
    return (
      <TestingParticipantsPage
        schoolId={Number(schoolId)}
        admissionTestingData={admissionTestingData}
      />
    );
  }

  return null;
};
